import {
  // deletee,
  post,
} from "./index";

export const signupIndividualClinician = (data) => {
  const request = {
    subUrl: `/direct_clinicians/sign_up`,
    data,
  };
  return post(request);
};
